import { isAxiosError } from "axios";

/**
 * バックエンドが返したエラーメッセージ（`detail`）を取り出す。取り出せない場合は既定の文言を返す。
 */
export const extractErrorDetail = (
  error: unknown,
  fallback: string
): string => {
  if (isAxiosError<{ detail?: unknown }>(error)) {
    const detail = error.response?.data?.detail;
    if (typeof detail === "string" && detail !== "") {
      return detail;
    }
  }
  return fallback;
};
